module.exports = __webpack_public_path__ + "img/cable.895627fc.jpeg";